<template>
  <div id="app">
    <div id="nav">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$cookie.set('BMAP_SECKEY', '', { secure: true })
    this.$cookie.set('SECKEY_ABVK', '', { secure: true })
    const cityCode = this.$route.query.cityCode
    this.$store.dispatch('updateCityCode', cityCode)
  },
  destroyed () {
    this.$store.dispatch('resetCityCode')
  }
}
</script>

<style lang="less">
body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}

#nav {
  height: 100%;
  .nav-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #66b1ff;
      outline: none;
      box-shadow: none;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -moz-tap-highlight-color: transparent;
    }

    i {
      font-size: 24px;
      margin-bottom: 4px;
    }
  }
}

.nav-item span {
  font-size: 14px;
}

.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
